import MuiIconButton, { IconButtonProps } from "@material-ui/core/IconButton";

import { withShowIf } from "../../../../../../../../../components/with-show-if/with-show-If.component";

export const IconButton = withShowIf((props: IconButtonProps) => <MuiIconButton {...props} />);
